import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import KanbanBoard from "./AufgabenBoard";
import CalendarView from "./CalendarView";

function MainAufgabeBoard() {
  return (
    <div className="min-h-screen p-4">
      <h1 className="text-3xl font-bold text-center mb-8">Mein Kanban-Board</h1>
      <Routes>
        <Route path="/" element={<KanbanBoard />} />
        <Route path="/calendar" element={<CalendarView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default MainAufgabeBoard;
